/**
 * Bank-connection provider returned by Backoffice GraphQL.
 *
 * `PLAID` is historical display-only — not a new-link path. Keep `PLAID` on
 * this union and `PROVIDER_LABELS`, keep it in `isLinkedBankConnectionProvider`,
 * and keep `plaid-mark.svg` / `PlaidIcon` in `_components/BankConnectionProviderIcon.tsx`
 * while Backoffice still returns `bankConnectionProvider: PLAID`.
 */
export type BankConnectionProvider = "STRIPE_FINANCIAL_CONNECTIONS" | "PLAID" | "MANUAL";

const PROVIDER_LABELS: Record<BankConnectionProvider, string> = {
  STRIPE_FINANCIAL_CONNECTIONS: "Stripe Financial Connections",
  PLAID: "Plaid",
  MANUAL: "Manual entry"
};

export function bankConnectionProviderLabel(provider?: BankConnectionProvider | null) {
  if (!provider) return null;
  return PROVIDER_LABELS[provider];
}

export function isLinkedBankConnectionProvider(provider?: BankConnectionProvider | null) {
  return provider === "STRIPE_FINANCIAL_CONNECTIONS" || provider === "PLAID";
}
